export default (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7925 15.8794C11.1825 16.2694 11.1825 16.8994 10.7925 17.2894C10.4025 17.6794 9.7625 17.6794 9.3825 17.2994L4.7925 12.7094C4.4025 12.3194 4.4025 11.6894 4.7925 11.2994L9.3825 6.70937C9.7725 6.31937 10.4025 6.31937 10.7925 6.70937C11.1825 7.09937 11.1825 7.72937 10.7925 8.11937L7.82874 11.0831L18.5 11.0831C19.0523 11.0831 19.5 11.5308 19.5 12.0831C19.5 12.6354 19.0523 13.0831 18.5 13.0831L7.99626 13.0831L10.7925 15.8794Z"
        fill="#616475"
      />
    </svg>
  );
};
